import { Fragment, KeyboardEvent, ReactElement, useContext, useEffect, useRef, useState } from "react";
import {
  Avatar,
  Button,
  ClickAwayListener,
  Divider,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper, useMediaQuery
} from "@mui/material";
import { useMsal, useAccount } from "@azure/msal-react";

import PersonIcon from "@mui/icons-material/Person";
import { SystemContext } from "../../context/systemContext";
import { resetUID } from "../../system/useFetch";
import SessionStatistics from "../../modules/security/sessionStatistics";
import ProfileDialog from "../dialogs/profileDialog";
import { breakpoints } from "../../system/theme";
import TransferToolDialog from "../dialogs/transferToolDialog";
import { getUID } from "../../system/utils";
import { isAzureMode } from "../../system/security";
import TaskDialog from "../../modules/management/task/taskDialog";


const AvatarComponent = (): ReactElement => {
  const { instance, accounts } = useMsal();
  const matchSM = useMediaQuery(`(min-width:${breakpoints.sm}px)`);
  const account = useAccount(accounts.length > 0 ? accounts[0] || {} : {});

  const systemContext = useContext(SystemContext);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openSessions, setOpenSessions] = useState(false);
  const [taskHash, setTaskHash] = useState<string | null>(null);
  const [openTool, setOpenTool] = useState(false);
  const [fullName, setFullName] = useState<string>();

  useEffect(() => {
    setFullName(account ? account.name : "");
  },  [account]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const onClickAway = () => {
    setOpen(false);
  };


  const handleOpenSession = () => {
    setOpenSessions(true);
  };

  const handleOpenTask = () => {
    setTaskHash(getUID());
  };

  const handleOpenUtility = () => {
    setOpenTool(true);
  };

  const handleListKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };

  const handleCloseSession = () => {
    resetUID();
    instance.logoutRedirect({ postLogoutRedirectUri: "/" }).then();
  };

  const showSession = systemContext.user && systemContext.user.permissions.find(x => x.code === "ADMIN");
  const showUtility = systemContext.user && systemContext.user.permissions.find(x => x.code === "TOOL");

  return(
    <Fragment>
      <Button ref={anchorRef} onClick={handleToggle}>
        {matchSM ? fullName : null}
        <Avatar className="ml-1" >
          <PersonIcon/>
        </Avatar>
      </Button>

      {isAzureMode() &&
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition={true} disablePortal={true}>
          {({ TransitionProps, placement }) =>
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}
            >
              <Paper>
                <ClickAwayListener onClickAway={onClickAway}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <MenuItem disabled={true}>{fullName}</MenuItem>
                    <MenuItem onClick={() => setOpenProfile(true)}>{systemContext.language.profile}</MenuItem>
                    {showSession && <MenuItem onClick={handleOpenSession}>{systemContext.language.session}</MenuItem>}
                    <MenuItem onClick={handleOpenTask}>Tasks</MenuItem>
                    {showUtility && <MenuItem onClick={handleOpenUtility}>Utility</MenuItem>}
                    <Divider/>
                    <MenuItem onClick={handleCloseSession}>{systemContext.language.logout}</MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          }
        </Popper>
      }

      <SessionStatistics open={openSessions} setOpen={setOpenSessions} />
      { systemContext.user && openProfile && <ProfileDialog open={openProfile} closed={() => setOpenProfile(false)} user={systemContext.user}/> }
      { taskHash && systemContext.user && <TaskDialog closed={() => setTaskHash(null)} user={systemContext.user} hash={taskHash}/> }
      { showUtility && <TransferToolDialog open={openTool} closed={() => setOpenTool(false)}/>}
    </Fragment>
  );
};

export default AvatarComponent;
